<template>
    <div class="highlights">

		<p><b>8+ years experience</b> across startups, consultancy and public sector, including zero to one development, marketplace apps, and NHS England</p>

		<p>Delivered <b>270% YoY growth</b> for marketplace app through backlog management, strategic planning and delivery for teacher-school marketplace with >20,000 DAU and 2,000 school customers across the UK</p>

		<p>Grew <b>subscription SaaS</b> for social housing at MadeTech from zero to 3 customers</p>

		<p>Public face of new SaaS for MadeTech, hosting webinars and attending conferences to grow brand awareness</p>

		<p>Ran election technology for the Labour Party 2017 and 2019 General Election including personally building volunteer.labour.org.uk</p>

		<p>Led development application holding 2 million people's sensitive personal data and managed support for over 10,000 users, and managed development of mass telephony service with over 10,000 users, holding personal information on over 5 million people</p>

		<p>Wrote strategic plan, roadmap, and specification for the Labour Party's new in-house CRM</p>

		<p>Key liaison and pivot point between senior management and technical colleagues on development strategy</p>

		<p>Coached public sector delivery teams in agile practices, and established community of practice for MadeTech product managers</p>

		<p>Established data strategy and roadmap for DVLA data programme</p>

    </div>
</template>


<script>

	export default {
		name: "WorkHighlights"
	}

</script>


<style>

.highlights {
  text-align: left;
  padding-bottom: 20px;
  max-width: 70%;
  min-width: 70%;
  margin: 0 auto;
}

</style>